<template>
  <div class="tw-w-modal">
    <div class="tw-border-b tw-border-border-light tw-p-6">
      <h2 class="tw-text-xl tw-font-bold tw-text-black">
        Do you want to convert this flight order?
      </h2>
    </div>
    <div class="tw-border-b tw-border-border-light tw-p-6">
      This action will convert this flight order into a {{ typeName }}. Are you
      sure?
    </div>
    <div
      v-if="error"
      class="tw-border-b tw-border-border-light tw-bg-red tw-p-6 tw-text-sm tw-text-white"
    >
      {{ error }}
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-p-6">
      <PassportButton
        label="Cancel"
        variant="basic"
        @@click="$emit('close')"
      />
      <PassportButton
        v-if="!error"
        :busy="isLoading"
        variant="primary"
        type="button"
        label="Yes, Convert"
        @@click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
import PassportButton from '@/components/PassportButton.vue'

export default {
  components: { PassportButton },
  name: 'PopupOrderFlightConfirmConversion',

  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],

  data() {
    return {
      isLoading: false,
      shouldRetry: false,
      error: '',
    }
  },

  computed: {
    typeName() {
      return this.type === 'flight' ? 'Flight' : 'Budget Grouping'
    },
  },

  methods: {
    async handleSubmit() {
      if (this.error) {
        this.$emit('close')
        return
      }

      this.error = ''
      this.isLoading = true

      try {
        const response = await this.$store.dispatch(
          'orderFlight/confirmConversion',
          { id: this.item.id, type: this.type }
        )

        if (this.type === 'flight') {
          this.$router.push(
            this.toRoute({
              name: 'EditCampaignFlight',
              params: {
                campaign: response.data.datas.campaignId,
                campaignFlight: response.data.datas.id,
              },
            })
          )
        } else {
          this.$router.push(
            this.toRoute({
              name: 'EditCampaignBudgetGroupingFlight',
              params: {
                campaign: response.data.datas.campaignId,
                campaignBudget: response.data.datas.budgetId,
                campaignFlight: response.data.datas.id,
              },
            })
          )
        }

        this.$store.dispatch('addToast', {
          type: 'info',
          value: 'Order successfully converted',
        })

        this.$emit('close')
      } catch (error) {
        if (error.response?.data?.errors?.length) {
          this.error = error.response.data.errors[0].message
        } else if (error.message) {
          this.error = error.message
        } else {
          this.error =
            "An error occurred, we couldn't proceed with your conversion confirmation. Please try again later. (Only an AdTrafficker person is allowed to do so)"
        }
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
